import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { TranslatedText } from '@/components/TranslatedText';
import { TestimonialsColumn } from '@/components/ui/testimonials-columns-1';
import proof1 from '@/assets/proof/proof-1.png';
import proof2 from '@/assets/proof/proof-2.png';
import proof3 from '@/assets/proof/proof-3.png';
import proof4 from '@/assets/proof/proof-4.png';
import proof5 from '@/assets/proof/proof-5.png';
import proof6 from '@/assets/proof/proof-6.png';
import proof7 from '@/assets/proof/proof-7.png';
import proof8 from '@/assets/proof/proof-8.png';

const columnTestimonials = [
  // USA
  { text: "These aren't motivational lessons — they show the actual workflow.", name: "Caleb M.", role: "Boise, Idaho, USA", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face", proofImage: proof1 },
  { text: "The structure removed guesswork completely.", name: "Mason R.", role: "Asheville, NC, USA", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face", proofImage: proof2 },
  { text: "Simple, practical and straight to the point. No fluff, just implementation.", name: "Tyler G.", role: "Fort Collins, CO, USA", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face" },
  { text: "I work full time and still managed to start. The lessons are short and easy to follow.", name: "Evan D.", role: "Des Moines, Iowa, USA", image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face" },
  { text: "Finally something actionable. Implemented day one.", name: "Connor B.", role: "Tulsa, OK, USA", image: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=100&h=100&fit=crop&crop=face", proofImage: proof3 },
  { text: "Clear roadmap from beginner to advanced. No guessing what to do next.", name: "Logan H.", role: "Reno, Nevada, USA", image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop&crop=face" },
  { text: "You just follow the system and it works.", name: "Dylan P.", role: "Chattanooga, TN, USA", image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=100&h=100&fit=crop&crop=face" },
  { text: "Saved me months of trial and error.", name: "Bryce K.", role: "Spokane, WA, USA", image: "https://images.unsplash.com/photo-1528892952291-009c663ce843?w=100&h=100&fit=crop&crop=face" },
  // UK
  { text: "I finally understood how online monetisation connects together.", name: "Lewis T.", role: "Nottingham, UK", image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=100&h=100&fit=crop&crop=face", proofImage: proof4 },
  { text: "Very beginner friendly. I had zero experience and never felt lost.", name: "Callum S.", role: "Norwich, UK", image: "https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=100&h=100&fit=crop&crop=face" },
  { text: "They show real workflows. Helped me understand how it actually works.", name: "Fraser M.", role: "Dundee, Scotland, UK", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=100&h=100&fit=crop&crop=face" },
  { text: "Biggest benefit: avoiding beginner mistakes. That alone paid for it.", name: "Rhys E.", role: "Swansea, Wales, UK", image: "https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=100&h=100&fit=crop&crop=face" },
  { text: "Perfect if you overthink starting. They simplify everything.", name: "Jordan A.", role: "Hull, UK", image: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop&crop=face" },
  // Canada
  { text: "Continuous updates. They actually improve the training instead of leaving it outdated.", name: "Owen C.", role: "Kelowna, Canada", image: "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=100&h=100&fit=crop&crop=face" },
  { text: "Easy to understand, even easier to apply.", name: "Nolan F.", role: "Halifax, Canada", image: "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=100&h=100&fit=crop&crop=face" },
  { text: "The accountability aspect pushed me to stay consistent.", name: "Brody S.", role: "Saskatoon, Canada", image: "https://images.unsplash.com/photo-1548372290-8d01b6c8e78c?w=100&h=100&fit=crop&crop=face" },
  // Australia
  { text: "Clear explanations, no confusion. Just follow the steps.", name: "Blake R.", role: "Geelong, Australia", image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=100&h=100&fit=crop&crop=face", proofImage: proof5 },
  { text: "Very practical education compared to traditional courses.", name: "Lachlan D.", role: "Toowoomba, Australia", image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face" },
  { text: "Small improvements weekly make a huge difference over time.", name: "Corey M.", role: "Newcastle, Australia", image: "https://images.unsplash.com/photo-1552058544-f2b08422138a?w=100&h=100&fit=crop&crop=face" },
  // NZ
  { text: "If you actually apply it, you'll see progress.", name: "Harrison B.", role: "Tauranga, NZ", image: "https://images.unsplash.com/photo-1564564321837-a57b7070ac4f?w=100&h=100&fit=crop&crop=face" },
  { text: "The environment keeps you motivated. Everyone is building something.", name: "Jayden L.", role: "Palmerston North, NZ", image: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=100&h=100&fit=crop&crop=face" },
  // Ireland
  { text: "Legit community. Real people, real results.", name: "Cian M.", role: "Galway, Ireland", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop&crop=face", proofImage: proof6 },
  { text: "Worth it for the structured approach alone.", name: "Darragh O.", role: "Limerick, Ireland", image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=100&h=100&fit=crop&crop=face" },
  // South Africa
  { text: "Support answered me at 2am… didn't expect that.", name: "Keenan V.", role: "Stellenbosch, SA", image: "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?w=100&h=100&fit=crop&crop=face" },
  { text: "Started as a beginner, now consistent implementation.", name: "Jared M.", role: "Umhlanga, SA", image: "https://images.unsplash.com/photo-1545167622-3a6ac756afa4?w=100&h=100&fit=crop&crop=face" },
  // Singapore & UAE
  { text: "The networking inside opened doors I didn't even know existed.", name: "Adrian T.", role: "Singapore", image: "https://images.unsplash.com/photo-1535931737580-a99567967ddc?w=100&h=100&fit=crop&crop=face", proofImage: proof7 },
  { text: "You're never stuck because help is always there.", name: "Daniel F.", role: "Al Ain, UAE", image: "https://images.unsplash.com/photo-1583195764036-6dc248ac07d9?w=100&h=100&fit=crop&crop=face" },
  // India & Philippines
  { text: "Best decision I made this year.", name: "Rohan M.", role: "Pune, India", image: "https://images.unsplash.com/photo-1530268729831-4b0b9e170218?w=100&h=100&fit=crop&crop=face", proofImage: proof8 },
  { text: "The workflow demonstrations make everything click.", name: "Nathaniel R.", role: "Cebu City, Philippines", image: "https://images.unsplash.com/photo-1557862921-37829c790f19?w=100&h=100&fit=crop&crop=face" },
  // Nigeria & Kenya
  { text: "Interactive lessons keep you focused. No boring lectures.", name: "Tobi A.", role: "Ibadan, Nigeria", image: "https://images.unsplash.com/photo-1506026022720-e9b1fcafcdaf?w=100&h=100&fit=crop&crop=face" },
  { text: "The community is the real value. Whenever I got stuck someone already solved it.", name: "Brian K.", role: "Nakuru, Kenya", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face&q=80&bri=10" },
];

const firstColumn = columnTestimonials.filter((_, i) => i % 3 === 0);
const secondColumn = columnTestimonials.filter((_, i) => i % 3 === 1);
const thirdColumn = columnTestimonials.filter((_, i) => i % 3 === 2);

const stats = [
  { value: "1,200+", label: "Members" },
  { value: "92%", label: "Satisfaction" },
  { value: "4.9/5", label: "Rating" },
];

export const LightTestimonialsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} id="success" className="py-12 sm:py-20 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground mb-3">
            <TranslatedText>Real Members. Real Implementation.</TranslatedText>
          </h2>
          <p className="text-base text-muted-foreground">
            <TranslatedText>Structured workflows, not motivational speeches.</TranslatedText>
          </p>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex justify-center gap-6 mb-10"
        >
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-2xl font-bold text-primary">{stat.value}</p>
              <p className="text-xs text-muted-foreground">
                <TranslatedText>{stat.label}</TranslatedText>
              </p>
            </div>
          ))}
        </motion.div>

        {/* Scrolling Testimonial Columns */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex justify-center gap-4 max-h-[500px] overflow-hidden [mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)]"
        >
          <TestimonialsColumn testimonials={firstColumn} duration={45} className="hidden sm:block" />
          <TestimonialsColumn testimonials={secondColumn} duration={55} />
          <TestimonialsColumn testimonials={thirdColumn} duration={50} className="hidden lg:block" />
        </motion.div>

        {/* Disclaimer */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-center text-xs text-muted-foreground mt-6 px-4"
        >
          <TranslatedText>* Results depend on execution, niche selection, and market conditions.</TranslatedText>
        </motion.p>
      </div>
    </section>
  );
};

export default LightTestimonialsSection;
